import Header from '../header/index.vue'
import treeNode from '../node.vue'

import { CampusAnnouncement } from '../group/regulatory-platform/index.js'
import { newsSafe, ceshi } from '../group/device-management/index.js'
import {
  regularitySchool,
  Callrecords,
  Aftersales,
  Electricity,
  Equipment,
  Attendance,
  CommunicationTime,
  Servicehotline,
  Sportsreport,
  Peoplereport,
  Alarmdetail,
  AournalSheet,
  Activeuser,
  Yichang
} from '../group/Systemreport/index.js'
import { RegisteredMember } from '../group/registered-member/index.js'
import {
  Uplinklog,
  Downlinklog,
  Entrylog,
  Memberjournal,
  Telecomuplinklog,
  CheckLog
} from '../group/log-management/index.js'
import {
  Corporateinformation,
  Officiaimg,
  Railset,
  Smsinterface,
  Rolemanagement,
  Smstypesetting,
  Jwdlongitude,
  Switchsettings,
  Huancunmanagement,
  StealthSettings,
  Usermanagement,
  Locationmanagement,
  healthSettings,
  Locationsettings,
  TimingTracking,
  Shuzimanagement
} from '../group/system-settings/index.js'
import {
  ManagementSchool,
  StudentGuanli,
  TeatcherGuanli,
  SuSheGuanLi,
  AskariGuanLi
} from '../group/jxt-school-guanli/index'
import {
  SchoolAffiche,
  CheckTongji,
  KaoqinTime,
  KaoqinNote,
  roomCeshi,
  Homework,
  ClassAdmin,
  Anquaneducation,
  ExamKaoshi,
  CheckGuanli,
  CardreaDing,
  CardreaDingPoint,
  StudentKQ,
  StudentLeave
} from '../group/jxt-teacher-guanli/index'
import {
  stepCountManagement,
  heartRateManagement,
  bodyTemperatureManagement,
  bloodOxygenManagement,
  bloodPressureManagement
} from '../group/health-management/index'
import {
  zuzhiJiagou,
  memberGuanli,
  gliyuanSettings
} from '../group/old-zzguanli/index'
import { jianKang, pingTai } from '../group/old-jiaowu/index'
import { Task, Record, Tongji, Dangan, Forms } from '../group/deyu/index.js'
import { StudentManage, TeatcherManage, TxStrategy } from '../group/face-mange/index.js'
import { LouDong, SusheRecord, SusheManagement } from '../group/Sushe/index.js'

export default {
  Header,
  treeNode,
  CampusAnnouncement,
  newsSafe,
  ceshi,
  regularitySchool,
  CommunicationTime,
  Callrecords,
  Aftersales,
  RegisteredMember,
  Electricity,
  Equipment,
  Attendance,
  Servicehotline,
  Sportsreport,
  Peoplereport,
  Alarmdetail,
  AournalSheet,
  Uplinklog,
  Downlinklog,
  Entrylog,
  Memberjournal,
  Telecomuplinklog,
  Activeuser,
  Corporateinformation,
  Officiaimg,
  Railset,
  Smsinterface,
  Rolemanagement,
  Smstypesetting,
  Jwdlongitude,
  Switchsettings,
  Huancunmanagement,
  StealthSettings,
  Usermanagement,
  Locationmanagement,
  Locationsettings,
  TimingTracking,
  Shuzimanagement,
  Yichang,
  stepCountManagement,
  heartRateManagement,
  bodyTemperatureManagement,
  bloodOxygenManagement,
  bloodPressureManagement,
  healthSettings,
  ManagementSchool,
  StudentGuanli,
  TeatcherGuanli,
  SuSheGuanLi,
  AskariGuanLi,
  SchoolAffiche,
  CheckGuanli,
  CheckTongji,
  CardreaDing,
  CardreaDingPoint,
  KaoqinTime,
  KaoqinNote,
  roomCeshi,
  Homework,
  ClassAdmin,
  Anquaneducation,
  ExamKaoshi,
  CheckLog,
  StudentKQ,
  StudentLeave,
  zuzhiJiagou,
  memberGuanli,
  gliyuanSettings,
  jianKang,
  pingTai,
  Task,
  Record,
  Tongji,
  Dangan,
  Forms,
  StudentManage,
  TeatcherManage,
  TxStrategy,
  LouDong,
  SusheRecord,
  SusheManagement
}
